<button (click)="refine()" class="clear-filter" *ngIf="state.hasRefinements"> clear filters </button>